import axios from 'axios';
import { db } from "./firebase";
import { collection, addDoc, serverTimestamp, doc, getDoc } from "firebase/firestore";

const ONESIGNAL_APP_ID = "e92e9533-4698-44b3-8a09-533f57231e53";
const ONESIGNAL_REST_KEY = "os_v2_app_5exjkm2gtbclhcqjkm7voiy6kmyj7qzjfeeu2tnmjrsipc2owvfv5h3y6ecoeori6ugfjyoijiwkdstug7bvvaftbqiff5prezpdepq";

export const enviarNotificacao = async (paraUID, deUID, deNome, tipo, dados = {}) => {
  if (!paraUID || paraUID === deUID) return;
  
  try {
    // 1. Grava no Sininho (Isto já funciona!)
    await addDoc(collection(db, "utilizadores", paraUID, "notificacoes"), {
      remetenteId: deUID,
      remetenteNome: deNome,
      tipo: tipo,
      dados: dados,
      lida: "false",
      timestamp: serverTimestamp()
    });

    // 2. Manda para o Bolso via OneSignal
    let textoPush = "enviou uma novidade! ⚽";
    if (tipo === "live") textoPush = "está em DIRETO! 🔴";
    if (tipo === "arena_pk") textoPush = "está em BATALHA! ⚔️";
    if (tipo === "champions_pk") textoPush = "entrou na CHAMPIONS! 🏆";
    if (tipo === "abriu_bancada") textoPush = "abriu a BANCADA! 🏟️";

    const body = {
      app_id: ONESIGNAL_APP_ID,
      include_external_user_ids: [paraUID], // Usa o ID do Firebase para encontrar o telemóvel
      headings: { "en": deNome },
      contents: { "en": textoPush },
      url: "https://web.app"
    };

    await axios.post("https://onesignal.com", body, {
      headers: { "Authorization": "Basic " + ONESIGNAL_REST_KEY }
    });

  } catch (error) {
    console.error("Erro no envio:", error);
  }
};
